import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Event } from 'src/app/common/events/event-base';
import { InMemoryCacheService } from 'src/app/common/cache/in-memory-cache.service';
import { UtilsService } from 'src/app/common/services/utils.service';
import { ChartModule } from 'primeng/chart';
import { CardModule } from 'primeng/card';
import { DropdownModule } from 'primeng/dropdown';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'gig-chart-wrapper',
  standalone: true,
  imports: [CommonModule, FormsModule, ChartModule, CardModule, DropdownModule, TranslateModule, TooltipModule],
  templateUrl: './chart-wrapper.component.html',
  styleUrls: ['./chart-wrapper.component.scss']
})
export class ChartWrapperComponent implements OnInit {


  @Output() chartWrapperEvent: EventEmitter<ChartWrapperEvent> = new EventEmitter<ChartWrapperEvent>();

  @Input() cardTitle: string;
  @Input() public subtitle: string;
  @Input() type: string;
  @Input() showDateRange: boolean = false;
  @Input() chartData: any;
  @Input() toolTipPath: string

  @Input() selectedDateRange: any = {
    name: 'Last 12 Months',
    value: 'last_12_months'
  };
  public  dateRangeOptions: any = [
    {name: 'Last 12 Months',value: 'last_12_months'},
    {name: 'Last 24 Months',value: 'last_24_months'},
  ];

  constructor(private utils: UtilsService, private cache: InMemoryCacheService) { }

  ngOnInit(): void {
    this.utils.logger.info(`ChartWrapperComponent.ngOnInit()`);
    const billingProducts = this.cache.billingProducts;
    const seoProduct = billingProducts?.filter(p => p.feature === 'seo')[0];
    if (seoProduct && seoProduct?.name.toLowerCase().includes('standard')) {
      this.dateRangeOptions = [
        ...this.dateRangeOptions,
        {name: 'Last 36 Months',value: 'last_36_months'},
      ];
    } else if (seoProduct && seoProduct?.name.toLowerCase().includes('premium') || seoProduct && seoProduct?.name.toLowerCase().includes('business')) {
      this.dateRangeOptions = [
        ...this.dateRangeOptions,
        {name: 'Last 48 Months',value: 'last_48_months'},
        {name: 'Since 2019',value: 'all_time'}
      ];
    }

  }

  onDateRangeChange(event) {
    this.utils.logger.info(`ChartWrapperComponent.onDateRangeChange() ${event}`);
    this.chartWrapperEvent.emit(new ChartWrapperEvent('ChartWrapper.DATE_RANGE_CHANGED', {type: this.type, dateRange: event.value}));
  }

}

export class ChartWrapperEvent extends Event {
  constructor(type: string, payload: any) {
    super(type, payload);
  }
}
